<template>
  <div class="layout-container">
    <!-- Layout background image -->
    <img :src="layoutPath" class="layout-image" alt="Layout Background">
    
    <!-- Machine icons and info -->
    <div 
      v-for="machine in machines" 
      :key="machine.machineCode"
      class="machine-container"
      :style="{ left: `${machine.x}px`, top: `${machine.y}px` }"
    >
      <!-- Machine icon -->
      <div class="machine-icon" :class="machine.status">
        <i class="fas fa-industry"></i>
      </div>
      
      <!-- Machine info table -->
      <div class="machine-info">
        <table>
          <tr>
            <td colspan="2" class="machine-code">{{ machine.machineCode }}</td>
          </tr>
          <tr>
            <td>需求數</td>
            <td class="value">{{ machine.demand }}</td>
          </tr>
          <tr>
            <td>生產數</td>
            <td class="value">{{ machine.production }}</td>
          </tr>
          <tr>
            <td>運行時間</td>
            <td class="value">{{ machine.runtime }}分</td>
          </tr>
          <tr>
            <td>WIP</td>
            <td class="value">{{ machine.wip }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SagLayoutMachines',
  
  props: {
    layoutPath: {
      type: String,
      required: true
    },
    machines: {
      type: Array,
      required: true,
      validator: function(value) {
        return value.every(machine => 
          machine.machineCode &&
          typeof machine.x === 'number' &&
          typeof machine.y === 'number' &&
          ['red', 'yellow', 'green'].includes(machine.status) &&
          typeof machine.demand === 'number' &&
          typeof machine.production === 'number' &&
          typeof machine.runtime === 'number' &&
          typeof machine.wip === 'number'
        )
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.layout-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.machine-container {
  position: absolute;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: flex-start;
  gap: 6px;
  z-index: 1;
}

.machine-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.machine-icon.red {
  background-color: #FF4444;
}

.machine-icon.yellow {
  background-color: #FFBB33;
}

.machine-icon.green {
  background-color: #00C851;
}

.machine-info {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  font-size: 13px;
}

.machine-info table {
  border-collapse: collapse;
  width: 100%;
}

.machine-info td {
  padding: 2px 6px;
  border: 1px solid #eee;
  white-space: nowrap;
}

.machine-code {
  font-weight: bold;
  text-align: center;
  background-color: #f5f5f5;
  font-size: 14px;
  padding: 4px !important;
}

.value {
  text-align: right;
  min-width: 50px;
}
</style>
